import { removeToken, setToken,hasToken } from '../../utils/auth'

const state = {
    auth: hasToken(),
    realname: '',
    lives:[],
    interview:[],
    user:[],
}

const mutations = {
    SET_NAME: (state, realname) => {
        state.realname = realname
    },
    SET_PHONE_NUMBER: (state, phone_number) => {
        state.phone_number = phone_number
    },
    SET_USER: (state, user) => {
        state.user = user
    },
    SET_AUTH: (state, auth) => {
        state.auth = auth
    },
    SET_LIVES: (state, lives) => {
        state.lives = lives
    },
    SET_INTERVIEW: (state, interview) => {
        state.interview = interview
    },
}

const actions = {
    signin({ commit }, user) {
        setToken(user.token)
        commit('SET_AUTH', true)
        commit('SET_PHONE_NUMBER', user.phone_number)
        commit('SET_NAME', user.realname)
    },
    infocenter({ commit }, user) {
        commit('SET_AUTH', true)
        commit('SET_PHONE_NUMBER', user.phone_number)
        commit('SET_NAME', user.realname)
        commit('SET_USER', user)
    },
    signout({ commit },) {
        removeToken()
        commit('SET_AUTH', false)
        commit('SET_PHONE_NUMBER', '')
        commit('SET_NAME', '')
    },
    lives({ commit }, lives) {
        commit('SET_LIVES', lives)
    },
    interview({ commit }, interview) {
        commit('SET_INTERVIEW', interview)
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
